<template>
    <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="6"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <div class="i-form">
            <h3 class="h-title">业务进展情况</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>当前状态</th>
                    <td><span :style="{color:detailData.status == '2'||detailData.status == '4'?'#B82121':'#42AE0E'}">{{stateFormat(detailData.status)}}</span></td>         
                </tr>
                <tr>
                    <th>审核意见</th>
                    <td>{{exList.auditContent || '--'}}</td>         
                </tr>
                <tr>
                    <th>HASH值</th>
                    <td>{{detailData.blockchainHash}}</td>         
                </tr>
            </table>
        </div>
        <div class="i-form">
            <h3 class="h-title">公示公告详情</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">               
                <tr>
                    <th>存储类型</th>
                    <td>{{typeFormat(detailData.saveType)}}</td>
                </tr>
                
                <tr>
                    <th>服务类型</th>
                    <td>{{serviceFormat(detailData.serviceType)}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '41'">
                    <th>资产持有人名称</th>
                    <td>{{detailData.assetHolderName}}</td>
                </tr>
                <tr v-else>
                    <th>信息披露方名称</th>
                    <td>{{detailData.infoDisclosuresName}}</td>
                </tr>
                <tr>
                    <th>公告期限(天)</th>
                    <td>{{detailData.noticePeriod}}</td>
                </tr>
                <tr>
                    <th>公告场所</th>
                    <td>{{placeFormat(detailData.noticePlace)}}</td>
                </tr>
                <tr>
                    <th>成员单位名称</th>
                    <td>{{detailData.lawFirmName}}</td>
                </tr>
                <tr>
                    <th>权威节点</th>
                    <td>{{nodeFormat(detailData.authorityNode)}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '41'">
                    <th>资产名称</th>
                    <td>{{detailData.noticeName}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '42'">
                    <th>拟投资区域</th>
                    <td >{{detailData.proposedInvestmentArea}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '43'">
                    <th>项目名称</th>
                    <td>{{detailData.noticeName}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '42' || detailData.serviceType == '43'" >
                    <th>拟合作方式</th>
                    <td >{{detailData.proposedCooperationMode}}</td>
                </tr>
                <tr>
                    <th>{{detailData.serviceType == '41'?'资产规模(万元)': detailData.serviceType == '42'?'拟投资资金规模(万元)':'预算金额(万元)'}}</th>
                    <td>{{setComdify(detailData.noticeRelateAmount,4)}}</td>
                </tr>
                <tr>
                    <th>共识金额（万元）</th>
                    <td>{{setComdify(detailData.consensusAmount,4)}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '41'">
                    <th>资产类别</th>
                    <td>{{detailData.assetType}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '41'">
                    <th>资产相关</th>
                    <td>{{detailData.assetRelate ||'--'}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '42'">
                    <th>预期投资回报率(%/年)</th>
                    <td>{{detailData.expectedInvestment}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '42'">
                    <th>拟投资标的</th>
                    <td>{{detailData.proposedInvestmentAsset}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '42'">
                    <th>拟投资期限</th>
                    <td>{{detailData.proposedInvestmentPeriod}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '43'">
                    <th>项目所在地</th>
                    <td>{{detailData.projectLocation}}</td>
                </tr>
                <tr v-if="detailData.serviceType == '43'">
                    <th>合作方资质要求</th>
                    <td>{{detailData.partnersQualifyRequire}}</td>
                </tr>
                <tr>
                    <th>其他披露事项</th>
                    <td>{{detailData.otherDisclosures||'无披露'}}</td>
                </tr>  
                
                <tr v-if="detailData.subContractName">
                    <th>从合同名称</th>
                    <td> {{detailData.subContractName}}</td>
                </tr>
                <tr v-if="detailData.subContractName">
                    <th>从合同编号</th>
                    <td>{{detailData.subContractNo}}</td>
                </tr>
                <tr v-if="detailData.subContractName">
                    <th>从合同期限</th>
                    <td >{{detailData.subContractPeriodStart}}-{{detailData.subContractPeriodEnd}}</td>
                </tr>
                <tr v-if="detailData.subContractName">
                    <th>从合同金额</th>
                    <td >{{setComdify(detailData.subContractAmount,4)}} 万元</td>
                </tr>
                <tbody v-for="item in 10" :key="'sub'+item">
                    <tr v-if="detailData['subContractSignName'+item]">
                        <th>从合同签约主体{{item}}名称</th>
                        <td >{{detailData['subContractSignName'+item]}}</td>
                    </tr>
                </tbody>
                
                <tr>
                    <th>三证合一</th>
                    <td ><span class="file-link" v-if="detailData.threeCertOneFile[0]" @click="downloadFile(detailData.threeCertOneFile[0].url)">{{detailData.threeCertOneFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>法定代表人身份证</th>
                    <td ><span class="file-link" v-if="detailData.identityCardFile[0]" @click="downloadFile(detailData.identityCardFile[0].url)">{{detailData.identityCardFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>公司简介</th>
                    <td ><span class="file-link" v-if="detailData.companyProfileFile[0]" @click="downloadFile(detailData.companyProfileFile[0].url)">{{detailData.companyProfileFile[0].name}}</span></td>
                </tr>  

                <tr>
                    <th>公司简章</th>
                    <td ><span class="file-link" v-if="detailData.companyByelawFile[0]" @click="downloadFile(detailData.companyByelawFile[0].url)">{{detailData.companyByelawFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>高管人员简历</th>
                    <td ><span class="file-link" v-if="detailData.ggPersonResumeFile[0]" @click="downloadFile(detailData.ggPersonResumeFile[0].url)">{{detailData.ggPersonResumeFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>近两年财务报表及最近一期财务报表</th>
                    <td ><span class="file-link" v-if="detailData.financeReportFile[0]" @click="downloadFile(detailData.financeReportFile[0].url)">{{detailData.financeReportFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>灰名单查询结果：</th>
                    <td ><span class="file-link" v-if="detailData.riskResultFile[0]" @click="downloadFile(detailData.riskResultFile[0].url)">{{detailData.riskResultFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>征信报告：</th>
                    <td ><span class="file-link" v-if="detailData.creditReportFile[0]" @click="downloadFile(detailData.creditReportFile[0].url)">{{detailData.creditReportFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>信用报告：</th>
                    <td ><span class="file-link" v-if="detailData.thinktankReportFile[0]" @click="downloadFile(detailData.thinktankReportFile[0].url)">{{detailData.thinktankReportFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>公示公告信披服务申请书（客户-中数）</th>
                    <td ><span class="file-link" v-if="detailData.serviceApplyZsFile[0]" @click="downloadFile(detailData.serviceApplyZsFile[0].url)">{{detailData.serviceApplyZsFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>推介服务协议</th>
                    <td ><span class="file-link" v-if="detailData.suggestProtocolFile[0]" @click="downloadFile(detailData.suggestProtocolFile[0].url)">{{detailData.suggestProtocolFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>公示公告信息披露协议</th>
                    <td ><span class="file-link" v-if="detailData.infoDisclosuresProtocolFile[0]" @click="downloadFile(detailData.infoDisclosuresProtocolFile[0].url)">{{detailData.infoDisclosuresProtocolFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>法律综合服务协议</th>
                    <td ><span class="file-link" v-if="detailData.lawAllProtocolFile[0]" @click="downloadFile(detailData.lawAllProtocolFile[0].url)">{{detailData.lawAllProtocolFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>公示公告信披服务申请书（客户-律所）</th>
                    <td ><span class="file-link" v-if="detailData.serviceApplyLawFile[0]" @click="downloadFile(detailData.serviceApplyLawFile[0].url)">{{detailData.serviceApplyLawFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>拟存储文件</th>
                    <td ><span class="file-link" v-if="detailData.planSaveFile[0]" @click="downloadFile(detailData.planSaveFile[0].url)">{{detailData.planSaveFile[0].name}}</span></td>
                </tr>    
            </table>
        </div>
    </el-main>
  </el-container>
</template>
<script>
import leftMenu from '../contract/components/leftMenu'
	export default {
		name: "CDetail",
        components: {
            leftMenu
        },
		data() {
			return {
                setComdify: this.comdify,
				detailData: {},
				id: null,
				taskKey: '',
				taskId: '',
				exList: {},	
                typeOptions: [],
                serviceOptions: [],
                placeOptions: [],
                stateOptions: [],
			}
    },
    created() {
        window.scrollTo(0,0);
        this.id = this.$route.query.id;
        this.$api.api.getDicts("gsgg_save_type").then(response => {
            this.typeOptions = response.data;
        });
        this.$api.api.getDicts("gsgg_service_type").then(response => {
            this.serviceOptions = response.data;
        });
        this.$api.api.getDicts("gsgg_place").then(response => {
            this.placeOptions = response.data;
        });
        this.$api.api.getDicts("gsgg_state").then(response => {
            this.stateOptions = response.data;
        });
    },
    mounted() {
        this.getDetial();	
	},
    methods: {
        downloadFile(url){
            this.$api.api.downloadFile(url)
        },
        selectDictLabel(datas, value) {
            var actions = [];
            Object.keys(datas).some((key) => {
                if (datas[key].dictValue == ('' + value)) {
                    actions.push(datas[key].dictLabel);
                    return true;
                }
            })
            return actions.join('');
        }, 
        nodeFormat(val){
            if(val){
                let arr = JSON.parse(val)
                let nodeName = []
                arr.forEach(item => {
                    nodeName.push(item.name)
                })
                return nodeName.join('，')
            }else {
                return ''
            }
            
        },
        typeFormat (val) {
            return this.selectDictLabel(this.typeOptions, val);
        }, 
        stateFormat (val) {
            return this.selectDictLabel(this.stateOptions, val);
        },
        serviceFormat (val) {
            return this.selectDictLabel(this.serviceOptions, val);
        }, 
        placeFormat (val) {
            return this.selectDictLabel(this.placeOptions, val);
        }, 
        //获取详情
        getDetial() {
            this.$api.announcement.anDetail(this.id).then(res => {
                this.listLoading = false;
                if(res.code==200){
                    this.detailData = Object.assign({}, res.data); 	
                    this.detailData.threeCertOneFile = JSON.parse(this.detailData.threeCertOneFile || '[]');
                    this.detailData.identityCardFile = JSON.parse(this.detailData.identityCardFile || '[]');
                    this.detailData.companyProfileFile = JSON.parse(this.detailData.companyProfileFile || '[]');
                    this.detailData.companyByelawFile = JSON.parse(this.detailData.companyByelawFile || '[]');
                    this.detailData.ggPersonResumeFile = JSON.parse(this.detailData.ggPersonResumeFile || '[]');
                    this.detailData.financeReportFile = JSON.parse(this.detailData.financeReportFile || '[]');
                    this.detailData.riskResultFile = JSON.parse(this.detailData.riskResultFile || '[]');
                    this.detailData.creditReportFile = JSON.parse(this.detailData.creditReportFile || '[]');
                    this.detailData.thinktankReportFile = JSON.parse(this.detailData.thinktankReportFile || '[]');
                    this.detailData.serviceApplyZsFile = JSON.parse(this.detailData.serviceApplyZsFile || '[]');
                    this.detailData.suggestProtocolFile = JSON.parse(this.detailData.suggestProtocolFile || '[]');
                    this.detailData.infoDisclosuresProtocolFile = JSON.parse(this.detailData.infoDisclosuresProtocolFile || '[]');
                    this.detailData.lawAllProtocolFile = JSON.parse(this.detailData.lawAllProtocolFile || '[]');
                    this.detailData.serviceApplyLawFile = JSON.parse(this.detailData.serviceApplyLawFile || '[]');
                    this.detailData.planSaveFile = JSON.parse(this.detailData.planSaveFile || '[]');
                    this.exList = res.data.contractProjectAuditList[0] || {}
                }else {
                    this.$message.error(res.msg);
                }    
            });      
        },
    }
}
</script>

<style lang="less">
@import '../style.less';
</style>